
import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { fromEvent, merge, Observable } from 'rxjs';
import { DisplayMessage, GenericValidator, ValidationMessages } from 'src/app/utils/generic-form-validation';

import { LoginModel } from '../models/login.model';
import { LocalCookiesService } from '../services/local-cookie.service';
import { LoginService } from '../services/login.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  // @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  loginForm: FormGroup;
  dadosLogin: LoginModel;
  displayMessage: DisplayMessage
  validationMessages: ValidationMessages;
  validator: GenericValidator;
  constructor(private loginService: LoginService,
    private fb: FormBuilder,
    private localCookie: LocalCookiesService,
    private router: Router,
    private toastrService: ToastrService) {
    // this.validationMessages = {
    //   email: {
    //     required: 'Informe o e-mail',
    //     email: 'E-mail inválido'
    //   },
    //   senha: {
    //     required: 'Informe a senha'
    //   }
    // }
    // this.validator = new GenericValidator(this.validationMessages);
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      senha: ['', [Validators.required]]
    });
  }
  // ngAfterViewInit(): void {
  //   let controlBlurs: Observable<any>[] = this.formInputElements
  //     .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
  //   merge(...controlBlurs).subscribe(() => { debugger;
  //     this.displayMessage = this.validator.processarMensagens(this.loginForm);
  //   });
  // }
  login() {
    if (this.loginForm.dirty && this.loginForm.valid) {
      this.dadosLogin = Object.assign({}, this.dadosLogin, this.loginForm.value);
      this.loginService.login(this.dadosLogin)
        .subscribe(
          response => {          
            this.localCookie.criar(response);
            let toastr = this.toastrService.success('Benvindo(a)' );
            this.router.navigate(['/inicio']);
            toastr.onHidden.subscribe(() => {
             

            });
           

          },
          falha => {
            let toastr = this.toastrService.error(falha.error, 'Erro');
            toastr.onHidden.subscribe(() => {
              this.loginForm.reset();

            });

          }
        );
    }
  }


}
